export const mockFirstDataGroup = [
  {
    color: '#004CE4',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'on_time',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 1,
  },
  {
    color: '#538CFF',
    value: 0,
    valueSuffix: 'project',
    supLabelTranslation: '',
    label: 'vpc_mgr_approval_pending',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 2,
  },
  {
    color: '#B1CBFF',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'pending_publication_on_the_internet',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 3,
  },
];

export const mockSecondDataGroup = [
  {
    color: '#BF1313',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'very_high',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 4,
  },
  {
    color: '#E92C2C',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'high_pcr_next_presentation',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 5,
  },
  {
    color: '#FCC0AA',
    value: 0,
    valueSuffix: 'menu_projects',
    supLabelTranslation: '',
    label: 'medium_pcr_next_presentation',
    percentage: 0,
    trailColor: '#F7F8FA',
    trailWidth: 10,
    strokeWidth: 10,
    categorization: 6,
  },
];
